import React, { useEffect, useState } from "react";
import { getPublicAccuracy } from "@/lib/apiClient";
import { ShieldCheck } from "lucide-react";

export const AccuracyBadge = () => {
  const [d, setD] = useState(null);
  useEffect(() => { getPublicAccuracy().then(setD).catch(() => setD(null)); }, []);
  if (!d || d.ftr_pct == null) return null;
  return (
    <div data-testid="accuracy-badge" className="mt-6 inline-flex flex-wrap items-center gap-x-3 gap-y-1 rounded-full border border-emerald-400/30 bg-emerald-400/10 px-4 py-2 text-sm">
      <ShieldCheck className="h-4 w-4 text-emerald-400" />
      <span className="font-mono text-lg font-bold text-emerald-300" data-testid="accuracy-badge-pct">{d.ftr_pct}%</span>
      <span className="text-white/80">of invoices read right first time</span>
      <span className="text-xs text-white/40" data-testid="accuracy-badge-note">Live · {d.first_time_right} of {d.reviewed} reviewed in the last {d.window_days} days</span>
    </div>
  );
};
